import { Component, Input } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { NumberControlComponent } from '../../../controls/standard/number-control/number-control.component';

@Component({
	selector: 'app-number-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, NumberControlComponent],
	templateUrl: './number-field.component.html',
	styleUrls: ['./number-field.component.scss'],
})
export class NumberFieldComponent extends BaseFieldComponent {
	@Input('min') public min: number | null = null;
	@Input('max') public max: number | null = null;

	public static override validators: ValidatorFn[] = [Validators.required];
}
